/**
 * DevExtreme (esm/integration/jquery/use_jquery.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import jQuery from "jquery";
import config from "../../core/config";
const useJQuery = config().useJQuery;
if (jQuery && false !== useJQuery) {
  config({
    useJQuery: true
  });
}
export default function () {
  return jQuery && config().useJQuery;
}